import styled from 'styled-components'

interface CollapseProp {
    showDivider: boolean
}

interface CollapseContentProp {
    isSafariDesktop: boolean
}

export const Collapse = styled.div<CollapseProp>`
    border-bottom-width: ${props => (props.showDivider ? '1px' : '0')};
    border-bottom-style: solid;
    border-bottom-color: rgba(22, 22, 22, 0.24);
    margin-top: 2.5rem;
`
export const CollapseHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    font-size: 1rem;
`
export const CollapseContent = styled.div<CollapseContentProp>`
    overflow: hidden;
    transition: ${props => (props.isSafariDesktop ? 'unset' : 'height 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms')};
    margin-top: 0.5rem;
    margin-bottom: 1rem;
`
